import { Flex, FlexProps, Text } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import SectionStack from 'components/common/SectionStack'
import { AmexLogo } from 'components/svg/AmexLogo'
import { IuguLogo } from 'components/svg/IuguLogo'
import { MastercardLogo } from 'components/svg/MastercardLogo'
import { SslSecureLogo } from 'components/svg/SslSecureLogo'
import { VisaLogo } from 'components/svg/VisaLogo'
import { H2 } from 'components/typography'
import { FC } from 'react'

interface SafetySectionProps extends FlexProps {
  showTitle?: boolean
}

const SafetySection: FC<SafetySectionProps> = ({ showTitle = false, ...rest }) => {
  return (
    <SectionStack>
      {showTitle && (
        <H2
          fontWeight={{ base: 700, lg: 600 }}
          fontSize={{ base: '1rem', lg: '17px' }}
          lineHeight={{ base: '1.25rem', lg: '24px' }}
          letterSpacing="-0.02em"
          pb="4px"
          borderBottom="2px solid #25241E"
        >
          Protegido por
        </H2>
      )}
      <Flex wrap="wrap" sx={{ gap: '2rem' }} p="4" align="center" justifyContent="space-between" {...rest}>
        <SslSecureLogo h="46px" w="74px" />
        <VisaLogo />
        <ImageBox
          src="/landings/google-safe-browsing_bw.webp"
          alt="site seguro"
          h="33px"
          w="165px"
          imgProps={{ htmlWidth: 495, htmlHeight: 99 }}
        />
        <MastercardLogo theme="grayscale" />
        <IuguLogo />
        <AmexLogo />
      </Flex>
    </SectionStack>
  )
}

export default SafetySection
